import React from 'react';
import { NavLink } from 'react-router-dom';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { iconShape } from '../../../../../../../../../shared/types';

const LinkWithoutChildren = ({ link }) => {
  const { icon, label, path } = link;

  return (
    <SidebarMenuItem>
      <NavLink to={path}>
        {({ isActive }) => (
          <SidebarMenuButton isActive={isActive} tooltip={label}>
            <FontAwesomeIcon icon={icon} />
            <span>{label}</span>
          </SidebarMenuButton>
        )}
      </NavLink>
    </SidebarMenuItem>
  );
};

LinkWithoutChildren.propTypes = {
  link: PropTypes.shape({
    icon: iconShape.isRequired,
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default LinkWithoutChildren;
